import { render, staticRenderFns } from "./CommonLinkBlank.vue?vue&type=template&id=a06b3512&"
import script from "./CommonLinkBlank.vue?vue&type=script&lang=js&"
export * from "./CommonLinkBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports